import { NavLink, Outlet } from 'react-router-dom'
import { LayoutDashboard, MapPin, Package, Settings, Wallet } from 'lucide-react'
import { cn } from '@/lib/cn'

const tabs = [
  { to: '/account', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/account/orders', label: 'Orders', icon: Package },
  { to: '/account/addresses', label: 'Addresses', icon: MapPin },
  { to: '/account/wallet', label: 'Wallet', icon: Wallet },
  { to: '/account/settings', label: 'Settings', icon: Settings },
]

/**
 * Customer account shell nested inside StorefrontLayout - keeps the storefront
 * navbar and footer while adding tabs over the account pages. Below sm the
 * tabs are a segmented card with icons above labels (client-approved Waly
 * reference); from sm up they stay the soft-fill pill row. Storefront recipe,
 * not Icewall portal chrome.
 */
export default function AccountLayout() {
  return (
    <div className="mx-auto w-full max-w-6xl px-5 py-8 sm:py-10">
      {/* Mobile: segmented icon card */}
      <nav
        aria-label="Account"
        className="grid w-full grid-cols-5 overflow-hidden rounded-2xl border border-foreground/10 bg-background shadow-sm sm:hidden"
      >
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 px-1 py-3 text-center transition-colors',
                isActive ? 'bg-foreground/5 text-primary' : 'text-foreground/60 hover:text-foreground',
              )
            }
          >
            <Icon className="size-5" />
            <span className="text-2xs font-semibold">{label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Desktop: pill row */}
      <nav aria-label="Account" className="hidden gap-1 overflow-x-auto sm:flex">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-foreground/5 font-semibold text-foreground'
                  : 'text-foreground/60 hover:text-foreground',
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  )
}
